import { useState, useEffect } from 'react';

export const usePasswordValidation = ({
  firstPassword = '',
  secondPassword = '',
  requiredLength = 6,
}) => {
  const [validLength, setValidLength] = useState<boolean>(false);
  const [passwordMatch, setPasswordMatch] = useState<boolean>(false);

  useEffect(() => {
    setValidLength(firstPassword.length >= requiredLength ? true : false);

    setPasswordMatch(
      firstPassword.length > 0 ? firstPassword === secondPassword : false,
    );
  }, [firstPassword, secondPassword]);

  return [validLength, passwordMatch];
};
